import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import { ProjectsPage } from './pages/ProjectsPage';
import { ProjectDetail } from './pages/ProjectDetail';
import { BlogPage } from './pages/BlogPage';
import { ArticlePage } from './pages/ArticlePage';
import { Login } from './pages/Login';
import { AdminDashboardRevamped as AdminDashboard } from './pages/admin/AdminDashboardRevamped';
import { AdminArticlesRevamped as AdminArticles } from './pages/admin/AdminArticlesRevamped';
import { AdminProjectsRevamped as AdminProjects } from './pages/admin/AdminProjectsRevamped';
import { AdminProfileSimplified as AdminProfile } from './pages/admin/AdminProfileSimplified';
import { ArticleEditor } from './pages/admin/ArticleEditor';
import { ProjectEditor } from './pages/admin/ProjectEditor';
// Removed RefreshAuth - file was deleted
import { ProtectedRoute } from './components/ProtectedRoute';
import PageTransition from './components/PageTransition';
import { ThemeProvider } from './context/ThemeContext';
// Removed ProjectsContext - using direct queries
import './index.css';
// Remove unused imports to clean up the codebase

// Ensure page starts at top on refresh
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <ThemeProvider>
          <Router>
              <Routes>
                <Route path="/" element={
                  <PageTransition>
                    <App />
                  </PageTransition>
                } />
                <Route path="/projects" element={
                  <PageTransition>
                    <ProjectsPage />
                  </PageTransition>
                } />
                <Route path="/project/:slug" element={
                  <PageTransition>
                    <ProjectDetail />
                  </PageTransition>
                } />
                <Route path="/blog" element={
                  <PageTransition>
                    <BlogPage />
                  </PageTransition>
                } />
                <Route path="/blog/:slug" element={
                  <PageTransition>
                    <ArticlePage />
                  </PageTransition>
                } />
                <Route path="/login" element={
                  <PageTransition>
                    <Login />
                  </PageTransition>
                } />
                <Route element={<ProtectedRoute />}>
                  <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
                  <Route path="/admin/dashboard" element={
                    <PageTransition>
                      <AdminDashboard />
                    </PageTransition>
                  } />
                  <Route path="/admin/projects" element={
                    <PageTransition>
                      <AdminProjects />
                    </PageTransition>
                  } />
                  <Route path="/admin/projects/new" element={
                    <PageTransition>
                      <ProjectEditor />
                    </PageTransition>
                  } />
                  <Route path="/admin/projects/edit/:id" element={
                    <PageTransition>
                      <ProjectEditor />
                    </PageTransition>
                  } />
                  <Route path="/admin/articles" element={
                    <PageTransition>
                      <AdminArticles />
                    </PageTransition>
                  } />
                  <Route path="/admin/articles/new" element={
                    <PageTransition>
                      <ArticleEditor />
                    </PageTransition>
                  } />
                  <Route path="/admin/articles/edit/:id" element={
                    <PageTransition>
                      <ArticleEditor />
                    </PageTransition>
                  } />
                  <Route path="/admin/profile" element={
                    <PageTransition>
                      <AdminProfile />
                    </PageTransition>
                  } />
                  {/* Removed refresh-auth route - file was deleted */}
                </Route>
              </Routes>
            </Router>
        </ThemeProvider>
    </HelmetProvider>
  </StrictMode>
);